import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  GiftSalesManagementAutocompleteResponse,
} from '@/repositories/generated';

type GiftSalesManagementAutocompleteRequestForm = {
  term: string | undefined;
};

type GiftSalesManagementAutocompleteStoreState = {
  searchCache: Record<string, GiftSalesManagementAutocompleteResponse>;
};

/**
 * 検索候補表示コンポーネント用にレスポンスをキャッシュするストア
 */
export const useGiftSalesManagementAutocompleteStore = defineStore('giftSalesManagementAutocomplete', {
  state: (): GiftSalesManagementAutocompleteStoreState => ({
    searchCache: {},
  }),
  getters: {
    // idを元にキャッシュから取得するcomputed。なければ自動補完APIを非同期で叩く
    getByIdOrDummy: (state) => (id: string): GiftSalesManagementAutocompleteResponse => {
      const cache = state.searchCache[id];
      if (cache) {
        return cache;
      }

      // 自動補完APIが１度だけ叩かれるように、キャッシュにダミーデータを差し込んでおく
      const dummyItem = { id, name: '' } as GiftSalesManagementAutocompleteResponse;
      state.searchCache[id] = dummyItem;
      (async () => {
        const res = await AutocompleteRepository.searchGiftSalesManagement({ term: id });
        res.forEach((it) => {
          state.searchCache[it.id] = it;
        });
      })();
      return dummyItem;
    },
  },
  actions: {
    async search(form: GiftSalesManagementAutocompleteRequestForm): Promise<GiftSalesManagementAutocompleteResponse[]> {
      const res = await AutocompleteRepository.searchGiftSalesManagement(form);
      res.forEach((it) => {
        this.searchCache[it.id] = it;
      });
      return res;
    },
  },
});
